/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Radio = require('backbone.radio');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetFilingDetails = require('../../common/services/GetFilingDetails');
var GetEntityExternalUsersByAccessLevel = require('../../common/services/GetEntityExternalUsersByAccessLevel');

var DepDraftFilingView = require('../views/DepDraftFilingView');

module.exports = function(filingId) {
  GetFilingDetails(filingId)
    .done(function(filingDetails) {
      NProgress.set(0.6);
      var formIdentifier = filingDetails.formIdentifier;
      var entityId = filingDetails.entityId;

      var BuildFilingPromise = Radio.channel('dp:filing').request('build:' + formIdentifier, {
        filingId: filingId,
        entityCategoryId: filingDetails.entityCategoryId,
        entityId: entityId,
        mode: 'int-new',
        isReadOnly: false
      });
      $.when(BuildFilingPromise, GetEntityExternalUsersByAccessLevel({ entityId: entityId, accessLevel: 1 }))
        .done(function(filingFormView, lawyers) {
          NavUtils.navigate('dep/filing/' + filingId + '/draft');
          filingFormView.model.set({
            filingId: filingId,
            filingDetails: filingDetails,
            lawyers: lawyers
          });
          Scaffold.content.show(
            new DepDraftFilingView({
              viewMode: 'int',
              filingFormView: filingFormView,
              model: new Backbone.Model({
                filingId: filingId,
                filingDetails: filingDetails
              })
            })
          );
          NProgress.done();
        })
        .fail(function(err) {
          NProgress.done();
        });
    })
    .fail(function(err) {
      NProgress.done();
    });
};
